import { Box } from '@mui/material'
import { ICowLightInfo } from 'models/ICattlesData'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import CattlesApiService from 'services/cattlesApiServices'
import { useAppSelector } from 'store/hooks'
import SkeletonEmptyCard from 'ui/skeleton/SkeletonEmptyCard'
import FatnessWidjet from '../shared/FatnessWidjet'
import LactationWidjet from '../shared/LactationWidjet'
import LamenessWidjet from '../shared/LamenessWidjet'

interface WidjetProps {
	cattleInfo: ICowLightInfo
}

const WidjetsInPasportPage = (props: WidjetProps) => {
	const { cattleInfo } = props
	const { permissions } = useAppSelector(state => state.authReducer)
	const [currentLactationYield, setCurrentLactationYield] = useState<number>(0)

	useEffect(() => {
		const fetchCurrentLactationYield = async () => {
			if (!cattleInfo?.id) {
				setCurrentLactationYield(0)
				return
			}

			const lactationLength = Number(cattleInfo.lactation_length) || 0
			const startDate = moment()
				.startOf('day')
				.subtract(Math.max(lactationLength - 1, 0), 'days')
				.valueOf()
			const endDate = moment().valueOf()

			try {
				const response = await CattlesApiService.getMilkingGraphByCowId(
					cattleInfo.id,
					startDate,
					endDate,
				)
				setCurrentLactationYield(response?.total_milk_sum ?? 0)
			} catch (error) {
				setCurrentLactationYield(0)
			}
		}

		void fetchCurrentLactationYield()
	}, [cattleInfo?.id, cattleInfo?.lactation_length])

	const hasFatnessLicense = Boolean(permissions?.license_fatness)

	const widgets = [
		permissions?.license_identification && (
			<LactationWidjet
				key='lactation'
				lactationYield={currentLactationYield}
				yieldStatus={cattleInfo?.yield_status}
			/>
		),
		hasFatnessLicense && (
			<FatnessWidjet
				key='fatness'
				fatness={cattleInfo?.fatness}
				lastMilking={cattleInfo?.fatness_change_dt}
				lactationDay={cattleInfo?.lactation_length}
				isWarning={cattleInfo?.fatness_status === 'attention'}
				isError={cattleInfo?.fatness_status === 'critical'}
			/>
		),
		permissions?.license_limpness && (
			<LamenessWidjet
				key='lameness'
				lameness={cattleInfo?.limpness}
				lastMilking={cattleInfo?.limpness_change_dt}
				treatmentStatus={cattleInfo?.treatment_status}
			/>
		),
	].filter(Boolean)

	return (
		<Box
			sx={{
				display: 'grid',
				gridAutoFlow: 'column',
				gridAutoColumns: 'minmax(0, 1fr)',
				gap: '24px',
				width: '100%',
				'& > *': {
					minWidth: 0,
					width: '100% !important',
					margin: 0,
				},
				'@media(max-width: 1200px)': {
					gridAutoFlow: 'row',
					gridAutoColumns: 'auto',
					gridTemplateColumns: 'minmax(0, 1fr)',
				},
			}}
		>
			{cattleInfo ? (
				widgets
			) : (
				<>
					{Array.from({ length: 3 }, (_, index) => (
						<React.Fragment key={index}>
							<SkeletonEmptyCard height={'36px'} />
						</React.Fragment>
					))}
				</>
			)}
		</Box>
	)
}

export default WidjetsInPasportPage
